import CreateOrderModal from "./components/order/CreateOrderModal";
import Vue from 'vue';

Vue.component('create-order-modal', CreateOrderModal);

$(document).ready(function () {
    function trans(translation) {
        var language = document.documentElement.lang;

        return _.get(window.i18n, language + "." + translation);
    }
    if (document.getElementById('order_hidden')) {
        let counter = 0;
        $('#addProduct').on('click', function (){

            if( $('#order_product').val() != "" || $('#qty').val()!=""){
                let qty = $('#qty').val();
                let productSkuString = $('#order_product').val();
                let productArr = productSkuString.split('~');
                let productName = productArr[0];
                let productSku = productArr[1];
                $.ajax({
                    url: 'product_details',
                    type: "post",
                    dataType: "json",
                    data: {
                        name: productName,
                        sku: productSku
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        $('#order_product').val('');

                        $.each(data, function (key, value) {
                            $('#productTable tr:last').after('<tr>' +
                                '<td>butta</td>' +
                                '<td>'+$('#qty').val()+'<input type="hidden" value="'+$('#qty').val()+'" name="qty['+counter+']['+value["id"]+']" /></td>' +
                                '<td>'+value["sku"]+'</td>' +
                                '<td>'+value["name"]+'</td>' +
                                '<td>'+value["manufacturer"]+'</td>' +
                                '<td>'+value["commodity_code"]+'</td>' +
                                '<td>'+value["country_of_manufacturer"]+'</td>' +
                                '<td>'+value["price_gros"]+'</td>' +
                                '<td>'+value["price_net"]+'</td>' +
                                '<td>'+value["status"]+'</td>' +
                                '<td>'+value["weight"]+'</td>' +
                                '<td>'+value["width"]+'</td>' +
                                '<td>'+value["height"]+'</td>' +
                                '<td>'+value["length"]+'</td>' +
                                '</tr>');
                            counter++;
                        });

                        $('#qty').val('')

                    },
                    error: function () {

                    }
                });
            }else{
                alert("missing values");
            }


        });

        let availableProducts = [];
        $('#cb_abteilung_autocomplete').on('change', function(){

            $.ajax({
                url: 'getproductbyabteil/' +  $('#cb_abteilung_autocomplete').val(),
                type: "get",
                dataType: "json",
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                   // availableProducts
                    $('#availableProducts').val('');
                    console.log(data);
                    var arr = "";
                    $.each(data, function (key, value) {
                        arr = arr+value["name"]+"-"+value["sku"]+",";
                        availableProducts.push(value["name"]+"~"+value["sku"]);
                    });

                    $('#availableProducts').val(arr.substr(0, arr.length-1));
                },
                error: function () {

                }
            });
        });

        $( "#order_product" ).autocomplete({
            source: availableProducts
        });

        $( "#ordered_at_datePicker" ).datepicker({
            changeMonth: true,
            changeYear: true,
            showWeek: true,
            firstDay: 1
        });
        $( "#delivery_date_datePicker" ).datepicker({
            changeMonth: true,
            changeYear: true,
            showWeek: true,
            firstDay: 1
        });
        $.widget( "custom.combobox", {
            _create: function() {
                this.wrapper = $( "<span>" )
                    .addClass( "custom-combobox" )
                    .insertAfter( this.element );

                this.element.hide();
                this._createAutocomplete();
                this._createShowAllButton();
            },

            _createAutocomplete: function() {
                var selected = this.element.children( ":selected" ),
                    value = selected.val() ? selected.text() : "";

                this.input = $( "<input>" )
                    .appendTo( this.wrapper )
                    .val( value )
                    .attr( "title", "" )
                    .addClass( "  form-control autocompleteBox" )
                    .autocomplete({
                        delay: 0,
                        minLength: 0,
                        source: $.proxy( this, "_source" )
                    })
                    .tooltip({
                        classes: {
                            "ui-tooltip": "ui-state-highlight"
                        }
                    });

                this._on( this.input, {
                    autocompleteselect: function( event, ui ) {
                        ui.item.option.selected = true;
                        this._trigger( "select", event, {
                            item: ui.item.option
                        });
                    },

                    autocompletechange: "_removeIfInvalid"
                });
            },

            _createShowAllButton: function() {
                var input = this.input,
                    wasOpen = false;

                $( "<a>" )
                    .attr( "tabIndex", -1 )
                    .attr( "title", "Show All Items" )
                    .tooltip()
                    .appendTo( this.wrapper )
                    .button({
                        icons: {
                            primary: "ui-icon-triangle-1-s"
                        },
                        text: false
                    })
                    .removeClass( "ui-corner-all" )
                    .addClass( "custom-combobox-toggle ui-corner-right" )
                    .on( "mousedown", function() {
                        wasOpen = input.autocomplete( "widget" ).is( ":visible" );
                    })
                    .on( "click", function() {
                        input.trigger( "focus" );

                        // Close if already visible
                        if ( wasOpen ) {
                            return;
                        }

                        // Pass empty string as value to search for, displaying all results
                        input.autocomplete( "search", "" );
                    });
            },

            _source: function( request, response ) {
                var matcher = new RegExp( $.ui.autocomplete.escapeRegex(request.term), "i" );
                response( this.element.children( "option" ).map(function() {
                    var text = $( this ).text();
                    if ( this.value && ( !request.term || matcher.test(text) ) )
                        return {
                            label: text,
                            value: text,
                            option: this
                        };
                }) );
            },

            _removeIfInvalid: function( event, ui ) {

                // Selected an item, nothing to do
                if ( ui.item ) {
                    return;
                }

                // Search for a match (case-insensitive)
                var value = this.input.val(),
                    valueLowerCase = value.toLowerCase(),
                    valid = false;
                this.element.children( "option" ).each(function() {
                    if ( $( this ).text().toLowerCase() === valueLowerCase ) {
                        this.selected = valid = true;
                        return false;
                    }
                });

                // Found a match, nothing to do
                if ( valid ) {
                    return;
                }

                // Remove invalid value
                this.input
                    .val( "" )
                    .attr( "title", value + " didn't match any item" )
                    .tooltip( "open" );
                this.element.val( "" );
                this._delay(function() {
                    this.input.tooltip( "close" ).attr( "title", "" );
                }, 2500 );
                this.input.autocomplete( "instance" ).term = "";
            },

            _destroy: function() {
                this.wrapper.remove();
                this.element.show();
            }
        });

        $( "#cb_ship_to" ).combobox();
        $( "#cb_bill_to" ).combobox();
        $( "#toggles" ).on( "click", function() {
            $( "#cb_ship_to" ).toggle();
            $( "#cb_bill_to" ).toggle();
        });
    }
});